import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, formatMessage, FormattedNumber } from 'translate';
import Slider from 'rc-slider';
import NumberFormat from 'react-number-format';
import Tooltip from 'rc-tooltip';

import StyledSlider from './styles/Slider.styles';

import BalloonIcon from '../../../../icons/pay-it-forward/balloon.svg';

const ManualReward = ({
  className = '',
  disabled,
  editable,
  isMobile,
  max = 1,
  min = 0.1,
  step = 0.1,
  onChange,
  toggleEditMode,
  mustConvertToRefer,
  value,
}) => {
  const handleSliderChange = newValue => onChange(newValue);
  const handleInputChange = ({ floatValue }) => {
    if (floatValue || floatValue === 0) {
      onChange(floatValue);
    }
  };
  const validation = ({ value: newValue }) => (newValue >= 0) && (newValue <= max);
  const balloonOffSet = (Math.round((value - min) / step) / (max - min)) * 100 * step;

  return (
    <div className={className}>
      <Slider
        className="manual-slider"
        min={min}
        step={step}
        value={value || min}
        onChange={handleSliderChange}
        max={max}
        disabled={disabled || editable}
      >
        <StyledSlider offset={balloonOffSet || 0} isMobile={isMobile}>
          <Tooltip
            overlayClassName="twokey-tooltip-wrap"
            placement="top"
            animation="zoom"
            trigger={(disabled && !mustConvertToRefer) ? ['hover'] : []}
            overlay={formatMessage({ id: 'campaign_pay_it_forward.cant_change_distribution' })}
          >
            <button className="styled-balloon" disabled={disabled}>
              <img src={BalloonIcon} alt="balloon.svg" />
              <div className="input-overflow">
                <NumberFormat
                  value={value}
                  suffix="%"
                  displayType={editable ? 'input' : 'text'}
                  decimalScale={2}
                  inputMode="numeric"
                  pattern="[0-9]"
                  isAllowed={validation}
                  onValueChange={handleInputChange}
                />
              </div>
            </button>
          </Tooltip>
        </StyledSlider>
      </Slider>
      <div className="info-line">
        <span className="min-label">0%</span>
        <span className="max-label">{parseFloat((max || (min + 1)).toFixed(2))}%</span>
        <p className="keep">
          <FormattedMessage
            id="campaign_pay_it_forward.keep"
            values={{ keep: <span>{parseFloat((value || min).toFixed(2))}%</span> }}
          />
        </p>
        &nbsp;
        <p className="forward">
          <FormattedMessage id="main.forward" />
          <span>
            &nbsp;
            <FormattedNumber
              maximumFractionDigits={2}
              value={max - (value || min)}
            />%
          </span>
        </p>
        {!disabled && (
          <button
            className={`action-button ${editable ? 'active' : ''}`}
            onClick={toggleEditMode}
            disabled={disabled}
          >
            {formatMessage({ id: editable ? 'main.save' : 'main.edit' })}
          </button>)}
      </div>
    </div>
  );
};

ManualReward.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  editable: PropTypes.bool,
  isMobile: PropTypes.bool,
  max: PropTypes.number,
  min: PropTypes.number,
  step: PropTypes.number,
  onChange: PropTypes.func,
  toggleEditMode: PropTypes.func,
  mustConvertToRefer: PropTypes.bool,
  value: PropTypes.number,
};

export default ManualReward;
